import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox, ModalBody, ModalHeader } from '@ds';
import { CaseDonor } from '@lp/features/CaseFormSections';
import { CaseStatus } from '@/api/apis/case';
import { isAllowedStatus } from '@/utils/helpers';
import { WolsSelector } from '../components/WolsSelector';
import { CaseDonorFormType } from './config';

export const EditCaseDonorForm = ({ status }: { status: CaseStatus }) => {
  const { control } = useFormContext<CaseDonorFormType>();

  const disableMainField = !isAllowedStatus({
    statusTo: CaseStatus.Declined,
    currentStatus: status,
    prohibitDeclined: true,
  });

  const disableDonorOr = !isAllowedStatus({
    statusTo: CaseStatus.OrganOnOCS,
    currentStatus: status,
    prohibitDeclined: true,
  });

  const disableContactPhone = !isAllowedStatus({
    statusTo: CaseStatus.AtTXCenter,
    currentStatus: status,
    prohibitDeclined: true,
  });

  const disabledFields = useMemo(
    () => ({
      donorHospitalId: disableMainField,
      donorHospitalDate: disableDonorOr,
      donorHospitalTime: disableDonorOr,
      donorHospitalTimeZone: disableDonorOr,
      opoId: disableMainField,
      opoContactId: disableMainField,
      secondaryOpoContactId: disableMainField,
      opoSourceContactPhone: disableContactPhone,
      secondaryOpoContactPhone: disableContactPhone,
      pediatricCase: disableMainField,
    }),
    [disableMainField, disableDonorOr, disableContactPhone],
  );

  return (
    <>
      <ModalHeader>
        <h2>Retrieval Info</h2>
      </ModalHeader>

      <ModalBody>
        <CaseDonor isEditModal disabled={disabledFields} hasPermission />

        <WolsSelector />

        <div className="flex justify-end">
          <Controller
            name="pediatricCase"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <Checkbox
                {...field}
                value="pediatricCase"
                size="md"
                isSelected={field.value}
                isDisabled={disabledFields.pediatricCase}
              >
                Under 40kg
              </Checkbox>
            )}
          />
        </div>
      </ModalBody>
    </>
  );
};
